import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import Pagination from "@mui/material/Pagination";
import { Constants } from "../Content";
import { PaginationSection } from "../ManageDataTab/ManageDataStyled";
import InputBase from "@mui/material/InputBase";
const DisplayTable = ({ headers, rows, loading }) => {
  const [filters, setFilters] = useState({});
  const [currentFilter, setCurrentFilter] = useState('');
  const [pageNumber, setPageNumber] = useState(Constants.INITALPAGENO);
  const [rowsPerPage] = useState(Constants.PAGECOUNT);
  const [order, setOrder] = React.useState(Constants.ASENDING);
  const [orderBy, setOrderBy] = useState("");
  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
  };
  
  console.log(headers,"headers");
  const createSortHandler = (property) => (event) => {
    setOrder(
      order === Constants.ASENDING ? Constants.DESCENDING : Constants.ASENDING
    );
    setOrderBy(property);
  };
  function descendingComparator(a, b, orderBy) {
    if (!a[orderBy]) return -1; 
    if (!b[orderBy]) return 1;
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === Constants.DESCENDING
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const handleFilterChange = (columnName, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [columnName]: value,
    }));
    setPageNumber(Constants.INITALPAGENO);
    setCurrentFilter(value===''?'':columnName);
  };
  const filteredData = rows?.filter((row) =>
    Object.entries(filters).every(([columnName, filterValue]) =>
    filterValue!==''
        ? row[columnName]?.toString()?.toLowerCase()?.includes(filterValue?.toLowerCase())
        : true
    )
  ).sort((a,b)=>a[currentFilter]-b[currentFilter]);

  const tableRows = [...filteredData];
  return (
    <div>
      <TableContainer component={Paper}>
        <Table aria-label="customized table" id="datatable">
          <TableHead>
            <TableRow>
              {headers?.map((header, index) => (
                <TableCell key={index} className={header?.sort?"column":"componentColumn"}>
                  {header.header}
                  {header?.sort && (
                    <TableSortLabel
                      active={orderBy === header.id}
                      direction={
                        orderBy === header.id ? order : Constants.DECENDING
                      }
                      onClick={createSortHandler(header.id)}
                    />
                  )}
                 {header?.sort && <div key={header.id} className="filterBox">
                    <InputBase
                      className="filter"
                      placeholder={`Search`}
                      value={filters[header.id] || ""}
                      onChange={(e) =>handleFilterChange(header.id, e.target.value)}
                    />
                  </div>}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows?.length > 0
              ? (rowsPerPage > 0
                  ? stableSort(
                      filteredData,
                      getComparator(order, orderBy)
                    ).slice(
                      (Number(pageNumber) - 1) * rowsPerPage,
                      (Number(pageNumber) - 1) * rowsPerPage + rowsPerPage
                    )
                  : tableRows
                )?.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {headers?.map((cell, cellIndex) => (
                      <TableCell size='small' key={cellIndex} className={cell.id==="country"?"boldRow":""}>
                        {row[cell.id]===undefined ||row[cell.id]===null ?"-": 
                                `${cell?.showdecimals ? Number(row[cell.id]).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 6 }):row[cell.id].toLocaleString()}${cell?.percentage?'%':''}`
                        }
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              :  (
                <TableRow>
                   <TableCell colSpan={6}  className="noquotecell" align="center" >
                      <p className="noquotetext">
                        {loading?Constants.FETCHINGDATA:Constants.NODATATABLE}
                      </p>
                    </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationSection>
        <Box className="paginationContainer">
          <Typography variant="h6">
            {tableRows?.length}
            <span> {Constants.TOTAL_RESULT}</span>
          </Typography>
          <Pagination 
            count={Math.ceil(tableRows?.length / rowsPerPage)}
            page={pageNumber}
            onChange={handleChangePage}
          />
        </Box>
      </PaginationSection>
    </div>
  );
};

export default DisplayTable;
